import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home'
import about from '@/view/about'
import contact from '@/view/contact'
import invite from '@/view/invite'
import realtime from '@/view/realtime'
import technical from '@/view/technical'
import products from '@/view/products'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    }, {
      path: '/about',
      name: 'about',
      component: about
    }, {
      path: '/contact',
      name: 'contact',
      component: contact
    }, {
      path: '/invite',
      name: 'invite',
      component: invite
    }, {
      path: '/realtime',
      name: 'realtime',
      component: realtime
    }, {
      path: '/products',
      name: 'products',
      component: products
    }, {
      path: '/technical',
      name: 'technical',
      component: technical
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js